import { AppSubModule } from 'src/interfaces';
import { CATALOGS_PROVIDER_TOKENS } from '../constants';
import { personServiceProvider } from './service-providers/PersonService.provider';

class PersonListModule extends AppSubModule {
  public providers = [{ token: CATALOGS_PROVIDER_TOKENS.PERSON_SERVICE, provider: personServiceProvider }];
}

export const personListModule = new PersonListModule();
